import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
  Popover,
  Snackbar,
  Table,
  TableBody,
    TableCell,  
  TableContainer,
  TableHead,
  TablePagination,
    TableRow,   
  Typography,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import styles from "../../../styles.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  Breadcrumb,
  CustomePopover,
  dateConversion,
  DeleteDialog,
  HandleSort,
  StyledTableCell,
  StyledTableRow,
} from "../../reusableComponent/Reusables";
import { useNavigate } from "react-router-dom";
import customerPoService from "../../../services/customerPo.Service";
import HeaderSection from "../../reusableComponent/HeaderSection";
import ScheduleEntryPrint from "./ScheduleEntryPrint";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import axios from "axios";
import CustomPagination from "../../reusableComponent/CustomPagination";
import axiosClient from "../../../configs/axios";

const ScheduleEntryList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.userInfo;

  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState();
  const [sortBy, setSortBy] = useState(null);
  const [rows, setRows] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const totalCount = useSelector(state => state.schedule_entry.total_count || 0);
  const defaultRowsPerPage = useSelector(state => state.schedule_entry.rows_per_page || 15);
  

  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage,
  });

  const [successMessage, setSuccessMessage] = useState(null);
  const [poFilterType, setPoFilterType] = useState("all");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [selectedCylinderDetails, setSelectedCylinderDetails] = useState([]);

  // Generate year range options (e.g., 2024-2025, 2025-2026)
  const generateYearRanges = () => {
    const currentYear = new Date().getFullYear();
    const yearRanges = [];
    for (let i = currentYear + 5; i >= currentYear - 5; i--) {
      yearRanges.push(`${i}-${i + 1}`);
    }
    return yearRanges;
  };

  useEffect(() => {
    setController(prev => ({
      ...prev,
      rowsPerPage: defaultRowsPerPage,
      page: 0,
    }));
  }, [defaultRowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  const parseChildDetails = (data) => {
    if (!Array.isArray(data)) {
      console.warn("API response is not an array:", data);
      return [];
    }
    return data.map(row => {
      let details = [];
      try {
        details = typeof row.child_details === 'string' ? JSON.parse(row.child_details) : row.child_details || [];
      } catch (e) {
        console.error(`Error parsing child_details for row ${row.entry_no || 'unknown'}:`, e);
        details = [];
      }
      const totalQty = details.reduce((acc, item) => acc + (parseFloat(item.qty_kg) || 0), 0);
      const totalBasicAmount = details.reduce((acc, item) => acc + (parseFloat(item.basic_amount) || 0), 0);
      return {
        ...row,
        totalQty,
        totalBasicAmount,
      };
    });
  };

  const fetchData = async () => {
    try {
      const baseParams = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: searchKey,
      };
      console.log("Fetching unfiltered data with params:", baseParams);
      const response = await customerPoService.getScheduleEntryList(baseParams);
      console.log("Unfiltered API response:", response);
      const parsedData = parseChildDetails(response);
      setRows(parsedData);
    
    } catch (error) {
      console.error("Error fetching data:", error.message, error.response?.data);
      setSuccessMessage("Error fetching data. Please try again.");
      setRows([]);
    }
  };

  const fetchfilterdata = async () => {
    if (poFilterType === "month" && !selectedMonth) {
      setSuccessMessage("Please select a month to filter.");
      return;
    }
    if (poFilterType === "year" && !selectedYear) {
      setSuccessMessage("Please select a year range to filter.");
      return;
    }
    try {
      const params = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: searchKey,
        filterType: poFilterType,
        month: selectedMonth || undefined,
        year: selectedYear ? selectedYear.split('-')[0] : undefined, // Use the start year of the range
      };
      console.log("Fetching filtered data with params:", params);
      const data = await customerPoService.getdatefilter(params);
      console.log("Filtered API response:", data);
      const parsedData = parseChildDetails(data);
      setRows(parsedData);
      if (parsedData.length === 0) {
        setSuccessMessage(`No records found for ${poFilterType === "month" ? selectedMonth : selectedYear}.`);
      }
    } catch (error) {
      console.error("Failed to fetch filtered data:", error.message, error.response?.data);
      setSuccessMessage("Error fetching filtered data. Please try again.");
      setRows([]);
    }
  };

  const handleClearFilter = () => {
    setPoFilterType("all");
    setSelectedMonth("");
    setSelectedYear("");
    setSearchKey("");
    setController(prev => ({ ...prev, page: 0 }));
    setRows([]);
    fetchData();
  };

  useEffect(() => {
    if (poFilterType === "all" && !selectedMonth && !selectedYear) {
      fetchData();
    } else if ((poFilterType === "month" && selectedMonth) || (poFilterType === "year" && selectedYear)) {
      fetchfilterdata();
    }
  }, [controller, poFilterType, selectedMonth, selectedYear]);

  const handleSearch = async (e) => {
    const searchValue = e.target.value;
    setSearchKey(searchValue);
    if (poFilterType === "all") {
      await fetchData();
    } else {
      await fetchfilterdata();
    }
  };

  const deleteRecord = async (id) => {
    try {
      await customerPoService.editDeleteScheduleEntry({
        entry_id: id,
        changedUpdatedValue: "delete",
      });
      setIsDelete(false);
      if (poFilterType === "all") {
        fetchData();
      } else {
        fetchfilterdata();
      }
      setSuccessMessage("Record deleted successfully");
    } catch (error) {
      console.error("Error deleting record:", error.message, error.response?.data);
      setSuccessMessage("Error deleting record");
    }
  };

  const handleDelete = (functions) => {
    setIsDelete(true);
    setDeleteInfo(functions);
  };

  const handleClose = (event, reason) => {
    setIsDelete(false);
    setDeleteInfo(null);
  };

  const handleSalesOrderClick = async (entry_no) => {
    try {
      const response = await axios.get(`/api/salesoder/${entry_no}`);
      const salesOrderData = response.data;
      navigate('/salesEntries/add-so', { state: { salesOrderData } });
    } catch (error) {
      console.error("Error fetching sales order data:", error);
    }
  };

  const totals = React.useMemo(() => {
    let totalQty = 0;
    let totalBasicAmount = 0;

    rows.forEach(row => {
      totalQty += parseFloat(row.totalQty || 0);
      totalBasicAmount += parseFloat(row.totalBasicAmount || 0);
    });

    return {
      totalQty: totalQty.toFixed(2),
      totalBasicAmount: totalBasicAmount.toFixed(2),
    };
  }, [rows]);

  const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date || 0) - new Date(a.entry_date || 0));
  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;

    const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
    setSelectedCylinderDetails([]);
  };

    const toPoUrl = (url) => {
    const idx = url.indexOf("uploads/");
    if (idx === -1) return url;
    const origin = (axiosClient.defaults.baseURL || "").replace(/\/api\/?$/, "");
    return `${origin}/${url.slice(idx)}`;
  };

  const getPoUrls = (row) => {
    try {
      const v = typeof row.upload_po === "string" ? JSON.parse(row.upload_po || "[]") : row.upload_po;
      return Array.isArray(v) ? v.filter(Boolean).map(toPoUrl) : [];
    } catch {
      return [];
    }
  };

  const isImageUrl = (url) => /\.(jpg|jpeg|png)(\?.*)?$/i.test(url);

  const handleOpenDialog = (row) => {
    setSelectedRow(row); // Make sure this runs before dialog opens
    // const parsed = safeParse(row.table_details);
    setSelectedCylinderDetails(safeParse(row.child_details));
    setOpenDialog(true);
  };
   const safeParse = (jsonString) => {
    try {
      return JSON.parse(jsonString || '[]');
    } catch (e) {
      return [];
    }
  };
  

  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb routeSegments={[{ name: "Customer PO List" }]} />

        <HeaderSection
          title="CUSTOMER PO LIST"
          addNewPath="/salesEntries/add-se"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={sortedRows}
          fields={["entry_no", "entry_date", "po_date","po_no", "cust_name", "sales_officer", "qty", "basic_amount"]}
          labels={["Entry No", "Entry Date", "PO Date","Po no","Customer Name", "Sales Officer", "Quantity", "Basic Amount Credit Limit"]}
          filename="Customer PO List"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
        />

        {/* <Box display="flex" gap={2} alignItems="center" mb={2} ml={2}>
          <Typography variant="subtitle1">Filter By:</Typography>
          <select
            value={poFilterType}
            onChange={(e) => {
              setPoFilterType(e.target.value);
              setSelectedMonth("");
              setSelectedYear("");
              setRows([]);
            }}
            style={{
              padding: "6px 12px",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
          >
            <option value="all">All POs</option>
            <option value="month">Month-wise PO</option>
            <option value="year">Year-wise PO</option>
          </select>

          {poFilterType === "month" && (
            <input
              type="month"
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
              style={{
                padding: "6px 12px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
            />
          )}

          {poFilterType === "year" && (
            <select
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              style={{
                padding: "6px 12px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "150px",
              }}
            >
              <option value="">Select Year Range</option>
              {generateYearRanges().map((range) => (
                <option key={range} value={range}>
                  {range}
                </option>
              ))}
            </select>
          )}

          <Button
            variant="contained"
            color="primary"
            onClick={fetchfilterdata}
            size="small"
            sx={{ textTransform: "none" }}
            disabled={(poFilterType === "month" && !selectedMonth) || (poFilterType === "year" && !selectedYear)}
          >
            Apply Filter
          </Button>

          {(poFilterType !== "all" || selectedMonth || selectedYear) && (
            <IconButton
              color="error"
              onClick={handleClearFilter}
              title="Clear Filters"
            >
              <CloseIcon />
            </IconButton>
          )}
        </Box> */}

        <Paper sx={{ width: '100%' }}>
          <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
            <Table size="small" stickyHeader>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="left" className={styles.table_head}>Entry No</StyledTableCell>
                  <StyledTableCell align="left" className={styles.table_head}>Entry Date</StyledTableCell>
                  <StyledTableCell align="left" className={styles.table_head} onClick={() => HandleSort("po_date", sortBy, setSortBy, rows)}>PO Date</StyledTableCell>
                  <StyledTableCell align="left" className={styles.table_head} onClick={() => HandleSort("po_no", sortBy, setSortBy, rows)}>PO No</StyledTableCell>
                  <StyledTableCell align="left" className={styles.table_head}>Customer Name</StyledTableCell>
                  <StyledTableCell align="left" className={styles.table_head}>Sales Officer</StyledTableCell>
                  <StyledTableCell align="left" className={styles.table_head}>Quantity</StyledTableCell>
                  <StyledTableCell align="left" className={styles.table_head}>Basic Amount</StyledTableCell>
                                    <StyledTableCell align="center" className={styles.table_head}>PO File</StyledTableCell>
                  <StyledTableCell align="center" className={styles.table_head}>Action</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody sx={{ backgroundColor: '#fff' }}>
                {Array.isArray(rows) && rows.length > 0 ? (
                  rows.map((row) => (
                    <StyledTableRow key={row.entry_no}>
                       <StyledTableCell
                                             align="left"
                                             className={`${styles.list_table_body}`}
                                           >
                                             <Typography
                                               sx={{
                                                 fontSize: "12px",
                                                 fontWeight: "bold",
                                                 cursor: "pointer",
                                                 color: "#1976d2",
                                                 textDecoration: "underline",
                                               }}
                                               onClick={() => handleOpenDialog(row)}
                                             >
                                               {row.entry_no || "N/A"}
                                             </Typography>
                       
                       
                                           </StyledTableCell>
                       <StyledTableCell align="left" className={styles.list_table_body}>{dateConversion(row.entry_date)}</StyledTableCell>
                      <StyledTableCell align="left" className={styles.list_table_body}>
                       {dateConversion(row.po_date)}
                      </StyledTableCell>
                      <StyledTableCell align="left  " className={styles.list_table_body}>{row.po_no || "N/A"}</StyledTableCell>
                      <StyledTableCell align="left" className={styles.list_table_body}>{row.customer_name}</StyledTableCell>
                      <StyledTableCell align="left" className={styles.list_table_body} onClick={() => handleSalesOrderClick(row.entry_no)}>
                        {row.sales_officer_name || "N/A"}
                      </StyledTableCell>
                      <StyledTableCell align="left" className={styles.list_table_body}>
                        {row.totalQty?.toFixed(2) || "0.00"}
                      </StyledTableCell>
                      <StyledTableCell align="left" className={styles.list_table_body}>
                        ₹{row.totalBasicAmount?.toFixed(2) || "0.00"}
                      </StyledTableCell>
                                            <StyledTableCell align="center" className={styles.list_table_body}>
                        {getPoUrls(row).length === 0 ? (
                          "—"
                        ) : (
                          <Box sx={{ display: "flex", gap: 0.5, justifyContent: "center", alignItems: "center" }}>
                            {getPoUrls(row).map((url, i) =>
                              isImageUrl(url) ? (
                                <a key={i} href={url} target="_blank" rel="noreferrer">
                                  <img src={url} alt="po"
                                    style={{ width: 36, height: 36, objectFit: "cover", borderRadius: 4, border: "1px solid #E2E8F0" }} />
                                </a>
                              ) : (
                                <a key={i} href={url} target="_blank" rel="noreferrer"
                                   style={{ fontSize: "12px", color: "#1976d2", textDecoration: "underline" }}>
                                  📄 PDF
                                </a>
                              )
                            )}
                          </Box>
                        )}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomePopover row={row} handleDelete={false} linkTo="/salesEntries/add-se" PrintComponent={ScheduleEntryPrint}
                          handleCancel={false}  showEdit={false} />
                      </StyledTableCell>
                    </StyledTableRow>
                  ))
                ) : (
                  <StyledTableRow>
                    <StyledTableCell align="center" colSpan={7}>No records found.</StyledTableCell>
                  </StyledTableRow>
                )}
                {rows.length > 0 && (
                <StyledTableRow sx={{  }}>
  <StyledTableCell
    colSpan={9}
    align="right"
    sx={{
      fontWeight: "bold",
      padding: "10px !important", 
    }}
  >
       Total Qty: {totals.totalQty}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; Total Basic Amount: ₹{totals.totalBasicAmount}
  </StyledTableCell>
</StyledTableRow>

                )}
              </TableBody>
            </Table>
          </TableContainer>
                       <CustomPagination
  page={controller.page}
  rowsPerPage={controller.rowsPerPage}
  totalCount={total_count || 0}
  onPageChange={(newPage) => handleChangePage(null, newPage)}
/>
        </Paper>




<Dialog
  open={openDialog}
  onClose={handleCloseDialog}
  maxWidth={false}
  sx={{
    "& .MuiDialog-paper": {
      margin: "auto",
      width: "92vw",
      maxHeight: "85vh",
      boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
      overflow: "hidden",
      fontFamily: "'Inter', Arial, sans-serif",
     
    },
  }}
>
  {/* ── Dialog Header (Navy) ── */}
  <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
    <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#fff", letterSpacing: "0.5px", fontFamily: "'Inter', Arial, sans-serif" }}>
      CUSTOMER PO DETAILS
    </Typography>
    <IconButton onClick={handleCloseDialog} sx={{ color: "#fff", p: 0.5 }}>
      <CloseIcon fontSize="small" />
    </IconButton>
  </Box>

  <DialogContent sx={{ padding: "20px 24px", background: "#F4F7FB", overflowY: "auto" }}>

    {/* ── Order Information Card ── */}
    <Box sx={{ background: "#fff", border: "1px solid #E2E8F0",  overflow: "hidden", mb: 2.5 }}>
      
      {/* Card Header */}
      <Box sx={{ background: "#2A4F7A", padding: "9px 18px", display: "flex", alignItems: "center", gap: 1 }}>
        <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#fff", fontFamily: "'Inter', Arial, sans-serif", letterSpacing: "0.4px" }}>
          📋  Order Information
        </Typography>
      </Box>

      {/* Caption Grid */}
      <Box sx={{ padding: "16px 20px" }}>
        <Grid container>

          {/* Row 1 */}
          <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
              Entry No
            </Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#1C3A5E", fontFamily: "'Inter', Arial, sans-serif" }}>
              {selectedRow?.entry_no || "—"}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
              Entry Date
            </Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
              {dateConversion(selectedRow?.entry_date) || "—"}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
              PO No
            </Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
              {selectedRow?.po_no || "—"}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={3} sx={{ borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
              PO Date
            </Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
              {dateConversion(selectedRow?.po_date) || "—"}
            </Typography>
          </Grid>

          {/* Row 2 */}
          <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", padding: "12px 16px" }}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
              Customer Name
            </Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
              {selectedRow?.customer_name || "—"}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", padding: "12px 16px" }}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
              Sales Officer
            </Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
              {selectedRow?.sales_officer_name || "—"}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={6} sx={{ padding: "12px 16px" }}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
              Delivery Address
            </Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
              {selectedRow?.delivery_address || "—"}
            </Typography>
          </Grid>

        </Grid>
      </Box>
    </Box>

    {/* ── Product Details Table ── */}
    <Box sx={{ background: "#fff", border: "1px solid #E2E8F0", overflow: "hidden" }}>

      {/* Table Card Header */}
     

      <TableContainer sx={{ maxHeight: "320px" }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {[
                "Sr No", "Product Code", "Product Description", "Unit Rate",
                "Transport Cost", "Quantity", "UOM", "PO Validity Date",
                "Basic Amount", "GST", "Total Amount"
              ].map((header) => (
                <TableCell
                  key={header}
                  align="center"
                  sx={{
                    backgroundColor: "#1C3A5E !important",
                    color: "#fff !important",
                    fontFamily: "'Inter', Arial, sans-serif",
                    fontWeight: 700,
                    fontSize: "12px",
                    padding: "10px 12px",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid rgba(255,255,255,0.1)",
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {selectedCylinderDetails.length > 0 ? (
              selectedCylinderDetails.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#fff" : "#F8FAFC",
                    "&:hover": { backgroundColor: "#EBF4FF" },
                  }}
                >
                  {[
                    index + 1,
                    row.prod_code || "—",
                    row.prod_description || "—",
                    row.unit_rate || "—",
                    row.transport_cost || "—",
                    row.qty_kg || "—",
                    row.uom || "—",
                    row.req_date ? new Intl.DateTimeFormat('en-GB').format(new Date(row.req_date)) : "—",
                    row.basic_amount || "—",
                    row.gst_amount || "—",
                    row.total_amount || "—",
                  ].map((val, ci) => (
                    <TableCell
                      key={ci}
                      align="center"
                      sx={{
                        fontSize: "12px",
                        fontFamily: "'Inter', Arial, sans-serif",
                        color: "#2D3748",
                        padding: "8px 12px",
                        borderBottom: "1px solid #EDF2F7",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {val}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={11} align="center"
                  sx={{ py: 5, fontSize: "13px", color: "#A0AEC0", fontFamily: "'Inter', Arial, sans-serif" }}>
                  No product details available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>

  </DialogContent>

  {/* ── Dialog Footer ── */}
  <Box sx={{ padding: "12px 24px", background: "#F8FAFC", borderTop: "1px solid #E2E8F0", display: "flex", justifyContent: "flex-end" }}>
    <Button
      onClick={handleCloseDialog}
      sx={{
        background: "#E53E3E",
        color: "#fff",
        fontSize: "13px",
        fontWeight: 600,
        textTransform: "none",
        padding: "7px 20px",
       
        fontFamily: "'Inter', Arial, sans-serif",
        "&:hover": { background: "#971f16" },
      }}
    >
      Close
    </Button>
  </Box>
</Dialog>

        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          deleteID={deleteInfo?.entry_id || null}
          displayName={deleteInfo?.entry_id || ""}
        />
        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => { if (reason !== 'clickaway') setSuccessMessage(""); }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};

export default ScheduleEntryList;